import { Profile } from './userProfile';

const santanderIds = new Set([21, 59, 120, 152]);

export const hasMultipleSantanderPermissions = (profile: Profile): boolean => !!profile.manageMultipleClients
  && profile.permissions.PER_CLIENT.length > 1
  && profile.permissions.PER_CLIENT.every((client) => santanderIds.has(client.clientId));

export const verifyProfileCanManageProgramming = (
  profile: Profile,
  clientId?: number,
  unitId?: number,
): boolean => !!(
  profile.permissions.isInstaller
  || profile.manageAllClients
  || (clientId !== undefined && profile.adminClientProg?.CLIENT_MANAGE.includes(clientId))
  || (unitId !== undefined && profile.adminClientProg?.UNIT_MANAGE.includes(unitId)));
